'use strict'

export default class Singles
{
  constructor( )
  {
    let self = this

    $(document).ready(function(){
      if( $('.item_modal').length > 0 ){
        self.slidesModal = []
        self.itemModal()

        $('.modal .close_button').on('click', function( event ){
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()

          $('.lean-overlay').click()
        })
      }
    })

    $(window).resize( ()=> {

    })

    $(window).on("orientationchange", ()=> {

    })

    $( window ).scroll( ()=> {

    })
  }

  itemModal() {
    let posTop = '',
        posBottom = ''

    if( window.innerWidth >= 1024 ) {
      posTop = '25%'
      posBottom = '15%'
    }
    else{
      if( window.innerWidth >= 768 ){
        posTop = '20%'
        posBottom = '20%'
      }
      else{
        posTop = '10%'
        posBottom = '10%'
      }
    }

    $('.item_modal a').leanModal({
      dismissible: true,
      opacity: .5,
      in_duration: 300,
      out_duration: 400,
      starting_top: posTop,
      ending_top: posBottom,
      slides: this.slidesModal,
      ready: function (modal, trigger) {
          setTimeout(() => {
              $.each(this.slides, function (i, val) {
                  if (typeof $(this)[0].update == 'function') {
                      $(this)[0].update()
                  }
              })

              $('.modal__slide').addClass('slide_initilized')
              $('.modal__slide').siblings('.loader').addClass('hide')
          }, 350)
      },
      complete: function () {
          $('.modal__slide').removeClass('slide_initilized')
          $('.modal__slide').siblings('.loader').removeClass('hide')
      }
    })

    let self = this

    $.each($('.item_modal'), function (i, val) {
      let $slide = $(this).find('.modal__slide')

      if ($slide.children('figure').length > 3) {
        let id = $slide.parent().attr('id')

        // Is slide
        $slide.addClass('with-slide')

        // Create wrapper
        $slide.append('<div class="swiper-wrapper"></div>')

        // Insert into wrapper all items
        $slide.find('.swiper-wrapper').append($slide.children('figure'))
        $slide.find('figure').addClass('swiper-slide')

        // Add buttons prev & next
        $slide.parent().append(`<div class="${id} swiper-button-next"></div>`)
        $slide.parent().append(`<div class="${id} swiper-button-prev"></div>`)

        let swiper = new Swiper(`#${id} .modal__slide`, {
          slidesPerView: 3,
          autoplay: true,
          nextButton: `#${id} .swiper-button-next`,
          prevButton: `#${id} .swiper-button-prev`
        })

        self.slidesModal.push(swiper)
      }

      let $view_more = $(this).find('.item_modal__content .view_more')

      setTimeout(function(){
        $view_more.css({
            //'width': $view_more.siblings().outerWidth(),
            //'height': $view_more.siblings().outerHeight()
        })
      }, 500)

      $('body').append( $(this).children('.modal') )
    })
  }
}
